import { createFileRoute } from "@tanstack/react-router";
import { UploadEnergyInvoice } from "~/components/upload-energiefactuur";

export const Route = createFileRoute("/(authenticated)/energiefactuur-uploaden/")({
  component: UploadEnergyInvoice,
});
